import legacyConfig from './legacyConfig.js';

export const PAGE_CONFIG = legacyConfig;

export function getPageConfig(section = 'program_summary') {
  return PAGE_CONFIG[section] || null;
}

export function listSections() {
  return Object.keys(PAGE_CONFIG);
}

export default PAGE_CONFIG;
